import src from "IMAGE";
export default { src, width: 206, height: 60, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADg4ODNOTk5HMjIyLSAgIBwWFhYTGhoaFhoaGhYREREOADk5OTR4eHhvOjo6NTc3Ny8xMTEqMzMzKzc3Ny8nJychgq0MAu3BFVgAAAAASUVORK5CYII="};
